import { render, staticRenderFns } from "./qrPhoto.vue?vue&type=template&id=6f63368e"
import script from "./qrPhoto.vue?vue&type=script&lang=js"
export * from "./qrPhoto.vue?vue&type=script&lang=js"
import style0 from "./qrPhoto.vue?vue&type=style&index=0&id=6f63368e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports